import { IMAGE_PATH_ROOT_ALL } from '@/domain/constants/ImagePath';

export const DEFAULT_IMAGE_19x10 = `${IMAGE_PATH_ROOT_ALL}/default_19x10_400_210.png`;

export const DEFAULT_IMAGE_5x2 =
  'https://news-pctr.c.yimg.jp/t/news-topics/images/tpc/eternal/2025/3/4/topics900x373.png';

export const DEFAULT_IMAGE_4x3 =
  'https://news-pctr.c.yimg.jp/t/news-topics/images/tpc/eternal/2025/3/4/topics1280x720.png';

export const DEFAULT_IMAGE_1x1 =
  'https://news-pctr.c.yimg.jp/r/iwiz-tpc/images/tpc/eternal/2017/10/27/1509081692_1427194511_1427194505_topics550x550.jpg';
export default class ThumbnailHelper {
  /**
   * 画像が読み込めない場合に設定されているサイズによって使用するデフォルト画像を取得する。
   *
   * @param width
   * @param height
   * @returns デフォルト画像のURL
   */
  public static getDefaultImage(width: string, height: string): string {
    // サイズにはpxが付与されているので削除
    const widthNumber = Number(width.replace('px', ''));
    const heightNumber = Number(height.replace('px', ''));
    // numberに変換できない場合はアスペクト比を1に倒す
    const aspectRatio = isNaN(heightNumber) || isNaN(widthNumber) ? 1 : widthNumber / heightNumber;
    if (Math.floor(aspectRatio * 10) === 19) {
      return DEFAULT_IMAGE_19x10;
    } else if (aspectRatio > 1) {
      // 横長画像
      return DEFAULT_IMAGE_4x3;
    } else {
      // 正方形画像
      return DEFAULT_IMAGE_1x1;
    }
  }
}
